import { Box, Button, Typography, styled } from "@mui/material";
import { APP_BACKGROUND_COLOR, APP_COLOR, TEXT_COLOR } from "../../theme";

export const ModalContainer = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  height: "auto",
  maxHeight: "100%",
  width: "70%",
  backgroundColor:APP_BACKGROUND_COLOR,
  border: "2px solid #000",
  padding: "20px",
  margin: "30px 0 20px 0",
  overflowY: "auto",
  boxShadow: "0px 0px 40px rgba(0, 0, 0, 0.8)",
  [theme.breakpoints.down("md")]: {
    width: "95%",
    backgroundColor:APP_BACKGROUND_COLOR,
    boxShadow: "0px 0px 40px rgba(0, 0, 0, 0.8)",
    padding: "15px",
  },
}));

export const TrackDetailsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: "20px",
  [theme.breakpoints.down("md")]: {
    display: "block",
  },
}));

export const styles = {
  headerButtonContainer: {
    display: "flex",
    justifyContent: "space-between",
    margin: "15px",
  } as const,
  trackImage: {
    height: "120px",
  } as const,
  trackDetailsContainer: {
    display: "flex",
    gap: "20px",
    margin: "5px",
    color:TEXT_COLOR
  } as const,
  nextButtonContainer: {
    display: "flex",
    marginTop: "20px",
  } as const,
  targetBox: {
    border: "1px solid gray",
    padding: "2px",
    width: "100px",
    borderRadius: "5px",
    textAlign: "center",
    ":hover": { border: "1.25px solid #edf1f5" },
    cursor: "pointer",
    color:TEXT_COLOR
  } as const,
  presetBox: {
    width: "150px",
    // height: "auto",
    border: "1px solid gray",
    textAlign: "center",
    borderRadius: "10px",
    padding: "2px",
    ":hover": {
      border: `1.25px solid ${APP_COLOR}`,
    },
    cursor: "pointer",
  } as const,
  presetsContainer: {
    with: "100%",
    height: "auto",
    margin: "10px",
    display: "flex",
    gap: "10px",
    flexWrap: "wrap",
    color:TEXT_COLOR
  } as const,
  backButton: {
    backgroundColor: APP_COLOR,
    height: "50px",
    width: "150px",
    margin: "3px",
  }as const,
  stageButton: {
    backgroundColor: APP_COLOR,
    height: "50px",
    width: "150px",
  }as const,
  paymentDetailsContainer: {
    marginTop: "50px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  }as const,
  enterPaymentMethodButtonContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  }as const,
  enterPaymentMethodButton:{
    backgroundColor: "rgb(39, 182, 203)",
    width: "250px",
    margin: "20px",
  }as const,
  dismissButton: {
    backgroundColor: "rgb(39, 182, 203)",
    width: "250px",
    margin: "20px",
  }as const
};

export const BottomButtonsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  marginTop: "20px",
  [theme.breakpoints.down("md")]: {
    display: "block",
  },
}));

export const GoBackButtonContainer = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    display: "flex",
    justifyContent: "center",
  },
}));

export const DetailsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  marginTop: "-12px",
  [theme.breakpoints.down("md")]: {
    margin: "12px",
  },
}));

export const NavButtons = styled(Button)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    fontSize: "12px",
  },
}));

export const PresetImageContainer = styled(Button)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  width: "100%",
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));

export const PresetSuggestionContainer = styled(Typography)(
  ({ theme }) => ({})
);

export const Image = styled("img")(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    width: "100px",
    height: "100px",
  },
}));